<template>
    <modal :modal-id="modalId" :title="modalTitle" :preloader="preloader" :modalExtraButton="modalExtraButton" class="add-edit-modal" @submit="submit" @close-modal="closeModal">
        <template slot="body">
            <app-overlay-loader v-if="preloader" />

            <div class="modal-sidebar" :class="this.preloader ? 'modal-sidebar-preloader' : ''">
                <div class="modal-contentbox-tabs" :class="this.inputs.timeline_state > 5 ? '' : 'tab-indent'">
                    <button v-if="this.inputs.timeline_state > 5 && this.selectedUrl" class="tab" :class="this.currentTab == 'hr_tasks' || this.currentTab == 'employee_tasks' ? 'active' : ''" @click.prevent="showTab('hr_tasks')">
                        <app-icon :name="'check-square'" width="25" height="25" />
                        <span>{{ $t("tasks") }}</span>
                    </button>

                    <button v-if="this.inputs.timeline_state > 5 && this.selectedUrl && this.inputs.status == 3" class="tab" :class="this.currentTab == 'quiz' ? 'active' : ''" @click.prevent="showTab('quiz')">
                        <i class="custom-icon custom-icon-course"></i>
                        <span>{{ $t("test_quiz") }}</span>
                    </button>

                    <button v-if="this.inputs.timeline_state > 5 && this.selectedUrl && this.inputs.status == 3" class="tab" :class="this.currentTab == 'feedback' ? 'active' : ''" @click.prevent="showTab('feedback')">
                        <app-icon :name="'message-circle'" width="25" height="25" />
                        <span>{{ $t("feedback") }}</span>
                    </button>

                    <button class="tab" :class="this.currentTab == 'employee' ? 'active' : ''" @click.prevent="showTab('employee')">
                        <app-icon :name="'user'" width="25" height="25" />
                        <span v-if="this.inputs.status == 3">{{ $t("employee") }}</span>
                        <span v-else>{{ $t("Candidate") }}</span>
                    </button>

                    <button class="tab" :class="this.currentTab == 'superiors' ? 'active' : ''" @click.prevent="showTab('superiors')">
                        <app-icon :name="'clipboard'" width="25" height="25" />
                        <span>{{ $t("superiors") }}</span>
                    </button>

                    <button class="tab" :class="this.currentTab == 'contacts' || this.currentTab == 'medical_contacts' ? 'active' : ''" @click.prevent="showTab('contacts')">
                        <app-icon :name="'phone'" width="25" height="25" />
                        <span>{{ $t("personal_contacts") }}</span>
                    </button>

                    <button v-if="this.selectedUrl && (this.tenant == 'studioreaktor' || this.tenant == 'localhost' || this.tenant == 'demo') && this.inputs.status != 3" class="tab" :class="this.currentTab == 'communication' ? 'active' : ''" @click.prevent="showTab('communication')">
                        <app-icon :name="'mail'" width="25" height="25" />
                        <span>Komunikace</span>
                    </button>
                </div>

                <div v-if="selectedUrl" class="mobile-action-footer">
                    <div class="desktop-footer">
                        <a v-if="this.tableId == 'talentpool'" href="" class="action-option" @click.prevent="sendToNextTimelineState()">
                            <div class="btn btn-primary btn-sm btn-circle btn-circle-xs">
                                <app-icon :name="'thumbs-up'" width="19" height="19" />
                            </div>
                            <span class="primary">{{ $t("start_hiring") }}</span>
                        </a>
                        <a class="action-option" href="" @click.prevent="closeModalAndOpen('notification')">
                            <div class="btn btn-primary btn-sm btn-circle btn-circle-xs">
                                <app-icon :name="'share'" width="19" height="19" class="mt-1" />
                            </div>
                            <span class="primary">{{ $t("share_with_manager") }}</span>
                        </a>
                        <a v-if="this.inputs.status == 3" href="" class="action-option" @click.prevent="closeModalAndOpen('rejection')">
                            <div class="btn btn-secondary btn-sm btn-circle btn-circle-xs">
                                <app-icon :name="'trash'" width="20" height="20" />
                            </div>
                            <span class="red">{{ $t("delete_employee") }}</span>
                        </a>
                        <a v-else href="" class="action-option" @click.prevent="closeModalAndOpen('rejection')">
                            <div class="btn btn-secondary btn-sm btn-circle btn-circle-xs">
                                <app-icon :name="'trash'" width="18" height="18" />
                            </div>
                            <span v-if="this.tableId == 'talentpool'" class="red">{{ $t("delete") }}</span>
                            <span v-else class="red">{{ $t("reject") }}</span>
                        </a>
                    </div>

                    <div class="mobile-footer">
                        <button type="button" class="btn btn-secondary btn-circle mr-2" @click.prevent="closeModalAndOpen('rejection')">
                            <app-icon :name="'trash'" width="20" height="20" />
                        </button>
                        <button type="button" class="btn btn-primary btn-circle mr-2" @click.prevent="closeModalAndOpen('notification')">
                            <app-icon :name="'send'" width="20" height="20" />
                        </button>
                    </div>
                </div>
            </div>

            <!--
            <div v-if="this.selectedUrl && this.timelineStatesLoaded && this.checklistsLoaded && !this.preloader && this.inputs.status == 3 && this.inputs.timeline_state == 7 && !this.inputs.event_date" id="onboarding-tutorial-steps" class="modal-contentbox w-100 pb-0">
                <div v-if="this.checklistsHr && this.checklistsHr.length === 0" class="modal-contentbox-row">
                    <div class="note note-silver row ml-0 mt-0">
                        <div class="col-sm-12 col-md-3 mt-1">
                            <img src="/images/illustration_onboarding.svg">
                        </div>
                        <div class="col-sm-12 col-md-9 mt-0">
                            <h3>{{ $t('enter_first_tasks_to_be_completed_by_employee') }}</h3>
                            <div class="mt-3 mb-3">
                                <button class="btn btn-light" @click.prevent="submit();closeModalAndOpen('schedule')">
                                    {{ $t('no_send_invite_to_employee') }}
                                </button>
                                <button class="btn btn-primary" @click.prevent="showTab('employee_tasks');">
                                    {{ $t('setup_tasks') }}
                                </button>
                            </div>
                        </div>

                    </div>
                </div>
                <div v-else-if="this.checklistsHr && this.checklistsHr.length !== 0" class="modal-contentbox-row">
                    <div class="note note-silver row ml-0 mt-0">

                        <div class="col-sm-12 col-md-3 mt-1">
                            <img src="/images/illustration_invitation.svg" style="margin-top: -30px !important;">
                        </div>
                        <div class="col-sm-12 col-md-8 mt-0">
                            <h3 class="text-left">Pošli zaměstnanci ahoy, <br>ať se může
    přihlásit na palubu!</h3>
    <button class="btn btn-primary" @click.prevent="submit();closeModalAndOpen('schedule')">
        {{ $t('invite_employee_button') }}
    </button>
                        </div>



                    </div>
                </div>
            </div>
        -->
            <div id="modal-contentbox-start"></div>
            <div v-if="this.selectedUrl && this.inputs.status == 3 && !this.inputs.event_date && !this.preloader && this.showBanners" class="modal-contentbox modal-contentbox-banner modal-contentbox-banner-onboarding w-100 pb-0">
                <div class="modal-contentbox-row">
                    <div class="note note-silver row ml-0 mt-2 pb-0">
                        <div class="col-sm-12 col-md-3 mt-1">
                            <img src="/images/illustration_invitation.svg" style="margin-top: -70px !important;" class="illustration-svg" />
                        </div>
                        <div class="col-sm-12 col-md-8 mt-0">
                            <h3 class="text-left mt-0 mb-3">{{ $t("send_employee_welcome_message") }} <br />{{ $t("so_he_can_login") }}</h3>
                            <button
                                class="btn btn-primary mb-4"
                                @click.prevent="
                                    submit();
                                    closeModalAndOpen('schedule');
                                "
                            >
                                {{ $t("invite_employee_button") }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="this.inputs.timeline_state == 6 && this.showMainNote == true" id="onboarding-tutorial-steps" class="modal-contentbox modal-contentbox-banner w-100 pb-0">
                <div v-if="this.preboardingGuideStep == 1" class="modal-contentbox-row">
                    <div class="note note-silver row ml-0">
                        <div class="col-sm-12 col-md-3 mt-1">
                            <img src="/images/illustration_handshake.svg" class="illustration-svg" />
                        </div>
                        <div class="col-sm-12 col-md-9 mt-0">
                            <span class="text-muted float-right">{{ $t("step") }} 1/4</span>
                            <h3>
                                {{ $t("talk_with_employee_that_you_choosed_him") }}<br />
                                <a :href="'tel:' + this.inputs.phone">
                                    <b>{{ this.inputs.phone }}</b>
                                </a>
                            </h3>
                            <div class="mt-3 mb-3">
                                <button class="btn btn-primary" @click.prevent="preboardingGuideStepAdd()">
                                    {{ $t("continue") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="this.preboardingGuideStep == 2" class="modal-contentbox-row">
                    <div class="note note-silver row ml-0 mt-0">
                        <div class="col-sm-12 col-md-3 mt-1">
                            <img src="/images/illustration_done.svg" class="illustration-svg" />
                        </div>
                        <div class="col-sm-12 col-md-9 mt-0">
                            <span class="text-muted float-right">{{ $t("step") }} 2/4</span>
                            <h3>{{ $t("enter_first_tasks_to_be_completed_by_employee") }}</h3>
                            <div class="mt-3 mb-3">
                                <button class="btn btn-light" @click.prevent="preboardingGuideStepBack()">
                                    {{ $t("back") }}
                                </button>
                                <button class="btn btn-primary" @click.prevent="preboardingGuideStepAdd()">
                                    {{ $t("continue") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="this.preboardingGuideStep == 3" class="modal-contentbox-row">
                    <div class="note note-silver row ml-0">
                        <div class="col-sm-12 col-md-3 mt-1">
                            <img src="/images/illustration_invitation.svg" class="illustration-svg" />
                        </div>
                        <div class="col-sm-12 col-md-9 mt-0">
                            <span class="text-muted float-right">{{ $t("step") }} 3/4</span>
                            <h3>
                                Prohlédněte si <a :href="'/onboarding/stranka?id=' + this.onboardingSiteId + '&job=' + this.inputs.job" target="_blank" title="Otevřít v novém okně">tuto onboarding stránku</a><br />
                                pro nalodění do firmy a proveďte případné úpravy
                            </h3>
                            <div class="mt-3 mb-3">
                                <button class="btn btn-light" @click.prevent="preboardingGuideStepBack()">
                                    {{ $t("back") }}
                                </button>
                                <button class="btn btn-primary" @click.prevent="preboardingGuideStepAdd()">
                                    {{ $t("continue") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-else-if="this.preboardingGuideStep == 4" class="modal-contentbox-row">
                    <div class="note note-silver row ml-0">
                        <div class="col-sm-12 col-md-3 mt-1">
                            <img src="/images/illustration_welcome.svg" class="illustration-svg" />
                        </div>
                        <div class="col-sm-12 col-md-9 mt-0">
                            <span class="text-muted float-right">{{ $t("step") }} 4/4</span>
                            <h3>{{ $t("invite_employee_his_preboarding") }}</h3>
                            <div class="mt-3 mb-3">
                                <button class="btn btn-light" @click.prevent="preboardingGuideStepBack()">
                                    {{ $t("back") }}
                                </button>
                                <button
                                    class="btn btn-primary"
                                    @click.prevent="
                                        inputs.timeline_state = 7;
                                        inputs.status = 3;
                                        inputs.event_date = '';
                                        submit();
                                        sendToNextTimelineState();
                                    "
                                >
                                    {{ $t("continue") }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="this.inputs.timeline_state == 2 && this.showMainNote" class="modal-contentbox modal-contentbox-banner w-100 pb-0">
                <div class="modal-contentbox-row">
                    <div class="note note-silver row ml-0">
                        <div class="col-sm-12 col-md-3 mt-1">
                            <img src="/images/illustration_welcome.svg" class="illustration-svg" />
                        </div>
                        <div class="col-sm-12 col-md-9 mt-0">
                            <h3 class="mb-0">
                                Pozvěte uchazeče na pohovor!<br />
                                <a :href="'tel:' + this.inputs.phone">
                                    <b>{{ this.inputs.phone }}</b>
                                </a>
                            </h3>
                            <div class="mt-3 mb-3">
                                <button class="btn btn-primary" @click.prevent="sendToNextTimelineState()">{{ $t("back") }}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-else-if="(this.inputs.timeline_state == 3 || this.inputs.timeline_state == 4 || this.inputs.timeline_state == 5) && this.showMainNote" class="modal-contentbox-row">
                <div class="note note-silver row ml-0">
                    <div class="col-sm-12 col-md-3 mt-1">
                        <img src="/images/illustration_welcome.svg" class="illustration-svg" />
                    </div>
                    <div class="col-sm-12 col-md-9 mt-0">
                        <h3 v-if="this.eventHasPassed">
                            Domluvte a zapište termín pohovoru pro {{ this.currentTimelineStateName }}.<br />
                            Minulý pohovor proběhl {{ formatEventDate(inputs.event_date) }}.<br />
                            <a :href="'tel:' + this.inputs.phone">
                                <b>{{ this.inputs.phone }}</b>
                            </a>
                        </h3>
                        <h3 v-else>
                            Domluvte a zapište termín pohovoru <br />
                            <a :href="'tel:' + this.inputs.phone">
                                <b>{{ this.inputs.phone }}</b>
                            </a>
                        </h3>
                        <button
                            class="btn btn-primary"
                            @click.prevent="
                                submit();
                                closeModalAndOpen('schedule')();
                            "
                        >
                            <app-icon :name="'arrow-right'" class="inline-feather-icon" width="20" height="20" />
                            Zapsat termín
                        </button>
                    </div>
                </div>
            </div>
            <div v-else class="banner-mobile-indent"></div>

            <div class="modal-contentbox-body" :class="this.currentTab == 'hr_tasks' || this.currentTab == 'employee_tasks' ? 'pt-0 pb-0' : ''">
                <form autocomplete="off" role="presentation" class="w-100 candidates-crud" :class="{ 'loading-opacity': preloader }" ref="form" :data-url="selectedUrl ? `admin/app/candidates/${inputs.id}` : `admin/app/candidates`">
                    <div class="form-group form-group-name row">
                        <strong v-if="this.inputs.name || this.inputs.surname">{{ this.inputs.name }} {{ this.inputs.surname }}</strong>
                        <strong v-else-if="this.selectedUrl">Načítám...</strong>
                        <strong v-else-if="!this.selectedUrl"> </strong>

                        <app-input type="stars" :list="ratingLists" :title="$t('rating')" v-model="inputs.rating" />
                    </div>
                    <div class="form-group row align-items-center mb-0 form-group-rating">
                        <div v-if="this.selectedUrl && this.inputs.status == 2" class="w-100 text-left col-md-12 mb-1 p-0">
                            <app-input id="inputs_timeline_state" class="large-input" type="select" :title="$t('timeline_state')" v-model="inputs.timeline_state" @mouseup="preboardingGuideStep == 2 ? showTab('superiors') : ''" :list="timelineStatesLists" :required="true" />
                        </div>
                        <div v-if="this.selectedUrl && this.inputs.status == 3" class="w-100 text-left col-md-12 mb-1 p-0">
                            <app-input id="inputs_timeline_state" class="large-input" type="select" :title="$t('timeline_state')" v-model="inputs.timeline_state" @mouseup="preboardingGuideStep == 2 ? showTab('superiors') : ''" :list="timelineStatesOnboardingLists" :required="true" />
                        </div>
                        <div v-if="this.selectedUrl && (this.inputs.status == 3 || this.inputs.timeline_state == 3 || this.inputs.timeline_state == 4 || this.inputs.timeline_state == 5)" class="w-100 text-left col-md-12 pr-0">
                            <label v-if="this.inputs.status == 3 && (this.inputs.event_date === null || this.inputs.timeline_state == 7)" for="inputs_event_date" class="col-sm-12 text-center p-0">
                                {{ $t("start_of_onboarding") }}

                                <span v-if="!this.inputs.event_date">{{ " – " + this.$t("no_date") }}</span>
                                <span v-else>{{ formatEventDate(inputs.event_date) }}</span>

                                <button
                                    class="btn btn-primary btn-sm btn-circle btn-circle-xs ml-0"
                                    :class="this.inputs.timeline_state > 6 && this.inputs.event_date === null ? 'btn-pulse-animation' : ''"
                                    @click.prevent="
                                        submit();
                                        closeModalAndOpen('schedule');
                                    "
                                    :title="$t('change_date')"
                                >
                                    <app-icon :name="'edit-3'" width="19" height="19" class="mb-1" />
                                </button>
                                <button v-if="this.inputs.event_date && !this.eventHasPassed" class="btn btn-primary btn-sm btn-circle btn-circle-xs pb-2  ml-0" @click.prevent="generateCalendar()"><app-icon :name="'calendar'" width="15" height="15" class="ml-1" />+</button>
                            </label>
                            <label v-else-if="this.inputs.timeline_state == 3 || this.inputs.timeline_state == 4 || this.inputs.timeline_state == 5" for="inputs_event_date" class="col-sm-12 text-center p-0">
                                {{ $t("start_of_interview") }}

                                <span v-if="this.eventHasPassed || !this.inputs.event_date">{{ " – " + this.$t("no_date") }}</span>
                                <span v-else>{{ formatEventDate(inputs.event_date) }}</span>

                                <button
                                    class="btn btn-primary btn-sm btn-circle btn-circle-xs ml-0"
                                    @click.prevent="
                                        submit();
                                        closeModalAndOpen('schedule');
                                    "
                                    :title="$t('change_date')"
                                >
                                    <app-icon :name="'edit-3'" width="19" height="19" class="mb-1" />
                                </button>
                                <button v-if="this.inputs.event_date && !this.eventHasPassed" class="btn btn-primary btn-sm btn-circle btn-circle-xs pb-2 ml-0" @click.prevent="generateCalendar()"><app-icon :name="'calendar'" width="15" height="15" class="ml-1" />+</button>
                            </label>
                        </div>
                    </div>

                    <div v-show="this.currentTab == 'communication'" class="modal-contentbox-row pr-0 pt-0">
                        <h5 v-if="this.inputs.email && this.inputs.name && this.inputs.surname" class="mb-2">
                            Komunikace s uchazečem
                        </h5>
                        <div v-if="this.inputs.email && this.inputs.name && this.inputs.surname" class="mb-4 tab-comment-data">
                            <app-mailbox-add-form :table-id="tableMailboxId" :action="null" :candidate-id="this.inputs.id" :candidate-event-date="null" :candidate-timeline-state="null" :candidate-name="this.inputs.name+' '+this.inputs.surname" :candidate-mail="this.inputs.email" :subject="this.mailboxOptions.total > 0 ? mailboxOptions.data[0].subject : 'Nová zpráva pro uchazeče o zaměstnání'" :user-name="user.loggedInUser.full_name" :user-photo="user.loggedInUser.img" class="loading-hidden" @changed="getMailbox()"></app-mailbox-add-form>
                            <app-mailbox v-if="mailboxLoaded" :table-id="tableMailboxId" :mailbox-messages="this.mailboxOptions" class="loading-hidden"></app-mailbox>
                        </div>
                    </div>

                    <div v-show="this.currentTab == 'superiors'" class="modal-contentbox-row modal-contentbox-column pt-0 pb-0 w-100"></div>

                    <div v-show="this.currentTab == 'superiors'" class="modal-contentbox-row pr-0 pt-0">
                        <h5 v-if="this.selectedUrl" class="mb-2">
                            {{ $t("internal_notes") }}
                        </h5>
                        <div v-if="this.selectedUrl" class="mb-4 tab-comment-data">
                            <app-comment-add-form :table-id="tableCommentId" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :status="this.inputs.status" :user-name="user.loggedInUser.full_name" :user-photo="user.loggedInUser.img" :candidate-name="this.inputs.name" class="loading-hidden"></app-comment-add-form>
                            <app-comment :table-id="tableCommentId" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :status="this.inputs.status" class="loading-hidden"></app-comment>
                        </div>

                        <div class="form-group row align-items-center">
                            <label for="inputs_assignee_hr" class="col-sm-12">
                                {{ $t("HR_manager") }}
                            </label>
                            <app-input id="inputs_assignee_hr" class="col-sm-12" :input-class="'form-control'" type="smart-select" v-model="inputs.assignee_hr" :list="userOptions" :label="$t('choose...')" :required="false" />
                        </div>
                        <div class="form-group row align-items-center">
                            <label for="inputs_assignee_manager" class="col-sm-12">
                                {{ $t("manager") }}
                            </label>
                            <app-input id="inputs_assignee_manager" class="col-sm-12" :input-class="'form-control'" type="smart-select" v-model="inputs.assignee_manager" :list="userOptions" :label="$t('choose...')" :required="false" />
                        </div>
                        <div class="form-group row align-items-center">
                            <label for="inputs_assignee_leader" class="col-sm-12">
                                {{ $t("leader") }}
                            </label>
                            <app-input id="inputs_assignee_leader" class="col-sm-12" :input-class="'form-control'" type="smart-select" v-model="inputs.assignee_leader" :list="userOptions" :label="$t('choose...')" :required="false" />
                        </div>
                        <div class="form-group row align-items-center">
                            <label for="inputs_assignee_buddy" class="col-sm-12">
                                {{ $t("buddy") }}
                            </label>
                            <app-input id="inputs_assignee_buddy" class="col-sm-12" :input-class="'form-control'" type="smart-select" v-model="inputs.assignee_buddy" :list="userOptions" :label="$t('choose...')" :required="false" />
                        </div>
                        <div class="form-group row align-items-center">
                            <label for="inputs_assignee_master" class="col-sm-12">
                                {{ $t("master") }}
                            </label>
                            <app-input id="inputs_assignee_master" class="col-sm-12" :input-class="'form-control'" type="smart-select" v-model="inputs.assignee_master" :list="userOptions" :label="$t('choose...')" :required="false" />
                        </div>
                        <div class="form-group row align-items-center">
                            <label for="inputs_assignee_foreman" class="col-sm-12">
                                {{ $t("foreman") }}
                            </label>
                            <app-input id="inputs_assignee_foreman" class="col-sm-12" :input-class="'form-control'" type="smart-select" v-model="inputs.assignee_foreman" :list="userOptions" :label="$t('choose...')" :required="false" />
                        </div>
                        <div class="col-md-6 p-0">
                            <a href="../../users-and-roles" target="_blank" class="btn btn-primary btn-sm mb-4">
                                {{ $t("invite_users") }}
                            </a>
                        </div>

                        <h5 class="mb-2 mt-4 cursor-pointer" @click.prevent="showMiniTab('tab-history-data')">
                            {{ $t("all_notification") }}
                            <div class="btn btn-primary btn-xs btn-circular d-inline-block title-tab-history-data">+</div>
                        </h5>
                        <div class="mb-5 tab-history-data" style="display:none;">
                            <app-history :dataSet="candidateHistory"></app-history>
                        </div>
                    </div>

                    <!-- <div v-if="this.selectedUrl && this.timelineStatesLoaded && (this.inputs.status == 3 || this.inputs.timeline_state == 6) && this.checklistsLoaded" v-show="this.currentTab == 'contacts'" class="modal-contentbox-row pt-0 w-100">
                    <div class="row tab-row mt-0">
                        <a v-if="this.inputs.timeline_state > 5 && this.selectedUrl" class="tab" :class="this.currentTab == 'contacts' ? 'active' : ''" @click.prevent="showTab('contacts')">
                            <app-icon :name="'phone'" width="25" height="25"/>
                            <span>{{ $t('personal_contacts') }}</span>
                        </a>
                        <a v-if="this.inputs.timeline_state > 5 && this.selectedUrl" class="tab" :class="this.currentTab == 'medical_contacts' ? 'active' : ''" @click.prevent="showTab('medical_contacts')">
                            <app-icon :name="'activity'" width="25" height="25"/>
                            <span>{{ $t('medical_contacts') }}</span>
                        </a>
                    </div>
                </div>-->
                    <div v-show="this.currentTab == 'contacts'" class="float-left w-90">
                        <div v-if="!this.selectedUrl && this.inputs.status == 3" class="note note-info w-100 mt-2 mb-3 text-left pl-4 ml-md-4 pt-5 pt-md-3 d-none d-md-block row">
                            <div class="col-sm-12 col-md-4 mt-1 float-left">
                                <img src="/images/illustration_happy.svg" />
                            </div>
                            <div class="col-sm-12 col-md-12 mt-2 mb-4">
                                <h3 class="text-left">{{ $t("hi_congrats_on_your_new_employee") }}</h3>

                                <br /><b>{{ $t("lets_go_fill_cv") }}</b
                                ><br /><br />{{ $t("we_recommand_to_fill_personal_mail_first") }}<br /><br /><br />
                            </div>
                            <div class="confetti">
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                                <div class="confetti-piece"></div>
                            </div>
                        </div>
                    </div>
                    <div v-show="this.currentTab == 'contacts'" class="modal-contentbox modal-contentbox-first float-left mb-5">
                        <div class="form-group form-group-relative row align-items-center">
                            <label for="inputs_phone" class="col-sm-12">
                                {{ $t("mobile_phone") }}
                            </label>
                            <app-input id="inputs_phone" class="col-sm-12" type="tel-input" v-model="phone" :placeholder="$t('type_contact_number')" />
                            <a :title="$t('call_phone')" v-if="this.inputs.phone && this.phone != ''" :href="'tel:' + this.phone.replace(/\s/g, '')"><i class="custom-icon custom-icon-phone"></i></a>
                        </div>
                        <div class="form-group form-group-relative row align-items-center">
                            <label for="inputs_email" class="col-sm-12">
                                {{ $t("email") }}
                            </label>
                            <app-input id="inputs_email" class="col-sm-12" type="email" v-model="inputs.email" :placeholder="$t('email_type_input')" :required="true" />
                            <a :title="$t('sent_mail')" v-if="this.inputs.email" :href="'mailto:' + this.inputs.email"><i class="custom-icon custom-icon-mail"></i></a>
                        </div>
                        <div class="form-group form-group-relative row align-items-center">
                            <label for="inputs_meta_personal_email" class="col-sm-12">
                                {{ $t("personal_email") }}
                            </label>
                            <app-input id="inputs_meta_personal_email" class="col-sm-12" type="email" v-model="inputs.meta_personal_email" :placeholder="$t('email_type_input')" :required="false" />
                            <a :title="$t('sent_mail')" v-if="this.inputs.meta_personal_email" :href="'mailto:' + this.inputs.meta_personal_email"><i class="custom-icon custom-icon-mail"></i></a>
                        </div>
                        <div class="row">
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_street" class="col-sm-12">
                                    Ulice
                                </label>
                                <app-input id="inputs_meta_street" class="col-sm-12" type="text" v-model="inputs.meta_street" autocomplete="off" />
                            </div>
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_house_no" class="col-sm-12">
                                    Číslo
                                </label>
                                <app-input id="inputs_meta_house_no" class="col-sm-12" type="text" v-model="inputs.meta_house_no" autocomplete="off" />
                            </div>
                        </div>

                        <div class="row">
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_city" class="col-sm-12">
                                    Město
                                </label>
                                <app-input id="inputs_meta_city" class="col-sm-12" type="text" v-model="inputs.meta_city" autocomplete="off" />
                            </div>
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_postal_code" class="col-sm-12">
                                    PSČ
                                </label>
                                <app-input id="inputs_meta_postal_code" class="col-sm-12" type="number" v-model="inputs.meta_postal_code" autocomplete="off" />
                            </div>
                        </div>

                        <div class="form-group row align-items-center">
                            <label for="inputs_meta_country" class="col-sm-12">
                                Země
                            </label>
                            <app-input
                                id="inputs_meta_country"
                                class="col-sm-12"
                                type="select"
                                v-model="inputs.meta_country"
                                :list="[
                                    { id: 'cz', value: 'CZ' },
                                    { id: 'sk', value: 'SK' },
                                ]"
                            />
                        </div>
                        <div class="form-group form-group-relative row align-items-center mb-0">
                            <label for="inputs_linkedin" class="col-sm-3">
                                {{ $t("linkedin") }}
                            </label>
                            <app-input id="inputs_linkedin" class="col-sm-12 mb-4" type="text" v-model="inputs.linkedin" :placeholder="$t('text_type_input')" :required="false" />
                            <a :title="$t('open_linkedin')" v-if="this.inputs.linkedin" :href="this.inputs.linkedin" target="_blank"><i class="custom-icon custom-icon-linkedin"></i></a>
                        </div>
                        <div class="form-group row align-items-center mb-0">
                            <label for="inputs_source" class="col-sm-12">
                                {{ $t("source") }}
                            </label>
                            <app-input id="inputs_source" class="col-sm-12 mb-4" type="select" v-model="inputs.source" :list="sourceLists" :required="false" />
                        </div>
                    </div>
                    <div v-show="this.currentTab == 'contacts'">
                        <div v-show="this.currentTab == 'contacts'" class="modal-contentbox modal-contentbox-last">
                            <div class="row">
                                <div class="form-group row align-items-center col-sm-12 col-md-6">
                                    <label for="inputs_name" class="col-sm-12">
                                        {{ $t("name") }}
                                    </label>
                                    <app-input id="inputs_name" class="col-sm-12 name" type="text" v-model="inputs.name" :placeholder="$t('add_name')" :required="true" />
                                </div>
                                <div class="form-group row align-items-center col-sm-12 col-md-6">
                                    <label for="inputs_surname" class="col-sm-12">
                                        {{ $t("surname") }}
                                    </label>
                                    <app-input id="inputs_surname" class="col-sm-12 name" type="text" v-model="inputs.surname" :placeholder="$t('add_surname')" :required="true" />
                                </div>
                            </div>

                            <div v-if="this.tenant == 'studioreaktor'" class="form-group row align-items-center mb-2">
                                <label for="inputs_job" class="col-sm-10">
                                    {{ $t("job_short") }}
                                </label>
                                <a href="/jobs" target="_blank" class="col-2 mb-1 text-right text-muted" :title="$t('edit_jobs')">
                                    <app-icon :name="'edit'" width="18" height="18" />
                                </a>
                                <app-input id="inputs_job" class="col-sm-12" type="select" :list="this.jobOptions" v-model="inputs.job" :required="true" />
                            </div>
                            <div v-if="this.selectedUrl && this.inputs.status == 3 && this.tenant == 'studioreaktor'" class="form-group form-group-relative row align-items-center">
                                <div class="col-sm-12 mb-sm-0 text-muted">
                                    {{ $t("start_of_onboarding") }}
                                    {{ formatEventDate(inputs.event_date) }}
                                    ({{ this.currentTimelineStateName }})
                                    <button
                                        class="btn btn-primary btn-sm btn-circle btn-circle-xs ml-0"
                                        :class="this.inputs.timeline_state > 6 && this.inputs.event_date === null ? 'btn-pulse-animation' : ''"
                                        @click.prevent="
                                            submit();
                                            closeModalAndOpen('schedule');
                                        "
                                        :title="$t('change_date')"
                                    >
                                        <app-icon :name="'edit-3'" width="19" height="19" class="mb-1" />
                                    </button>
                                </div>
                            </div>

                            <div v-if="this.inputs.status == 3" class="row">
                                <div class="form-group row align-items-center col-sm-12 col-md-6">
                                    <label class="col-sm-12 mb-sm-0">
                                        {{ $t("birthdate") }}
                                    </label>
                                    <app-input class="col-sm-12" type="date" v-model="inputs.birthdate" :placeholder="$t('select_valid_date')" />
                                </div>
                                <div class="form-group row align-items-center col-sm-12 col-md-6">
                                    <label for="inputs_meta_personal_identification_number" class="col-sm-12">
                                        {{ $t("meta_personal_identification_number") }}
                                    </label>
                                    <app-input id="inputs_meta_personal_identification_number" class="col-sm-12" type="text" v-model="inputs.meta_personal_identification_number" />
                                </div>
                            </div>

                            <div v-if="this.inputs.status == 3" class="row">
                                <div class="form-group row align-items-center col-sm-12 col-md-6">
                                    <label for="inputs_meta_birthplace" class="col-sm-12">
                                        {{ $t("meta_birthplace") }}
                                    </label>
                                    <app-input id="inputs_meta_birthplace" class="col-sm-12" type="text" v-model="inputs.meta_birthplace" />
                                </div>
                                <div class="form-group row align-items-center col-sm-12 col-md-6">
                                    <label class="col-sm-12 mb-0">
                                        {{ $t("gender") }}
                                    </label>
                                    <app-input class="col-sm-12" type="select" v-model="inputs.gender" :list="genderLists" />
                                </div>
                            </div>

                            <div v-if="this.inputs.status == 3" class="row">
                                <div class="form-group row align-items-center col-sm-12 col-md-6">
                                    <label for="inputs_meta_citizenship" class="col-sm-12">
                                        {{ $t("meta_citizenship") }}
                                    </label>
                                    <app-input id="inputs_meta_citizenship" class="col-sm-12" type="text" v-model="inputs.meta_citizenship" />
                                </div>
                                <div class="form-group row align-items-center col-sm-12 col-md-6">
                                    <label for="inputs_meta_insurance" class="col-sm-12">
                                        {{ $t("meta_insurance") }}
                                    </label>
                                    <app-input id="inputs_meta_insurance" class="col-sm-12" type="number" v-model="inputs.meta_insurance" />
                                </div>
                                
                            </div>

                            <div v-if="this.inputs.status == 3" class="form-group row align-items-center">
                                
                            </div>
                            <div class="form-group row align-items-center">
                                
                            </div>
                            <br /><br /><br /><br /><br />
                        </div>
                    </div>
                    <div v-show="this.currentTab == 'employee'" class="modal-contentbox float-left" :class="this.selectedUrl ? 'modal-contentbox-first mb-5' : 'w-100'">
                        <div v-if="this.selectedUrl" class="p-0 form-group row align-items-center mb-6">
                            <label class="col-sm-12 mb-2">
                                {{ $t("tag") }}
                            </label>
                            <div class="col-sm-12">
                                <app-tag-manager :tags="tags" v-model="inputs.tag" :list="tagOptions" list-value-field="name" :tag-preloader="tagPreloader" @storeTag="tagStoreData" @attachTag="attachTag" @detachTag="detachTag" />
                            </div>
                        </div>

                        <div v-if="this.selectedUrl" class="form-group row align-items-center">
                            <label class="col-sm-12">
                                {{ $t("skills") }}
                            </label>
                            <app-input id="inputs_skills" :skills="skills" class="col-sm-12" type="multi-create" :isAnimatedDropdown="true" v-model="inputs.skill" :multiCreatePreloader="multiCreatePreloader" :list="skillOptions" @storeSkill="skillStoreData" @attachSkill="attachSkill" @detachSkill="detachSkill" />
                        </div>

                        <div v-if="(this.tenant == 'studioreaktor' || this.tenant == 'localhost' || this.tenant == 'demo')" class="form-group form-group-relative row align-items-center">
                            <label for="inputs_meta_external_attachment" class="col-sm-12">
                                Portfolio
                            </label>
                            <app-input id="inputs_meta_external_attachment" class="col-sm-12" type="text" v-model="inputs.meta_external_attachment" autocomplete="off" />
                            <a v-if="this.inputs.meta_external_attachment" :href="this.inputs.meta_external_attachment" target="_blank"><i class="custom-icon custom-icon-home"></i></a>
                        </div>
                        <div v-if="(this.tenant == 'studioreaktor' || this.tenant == 'localhost' || this.tenant == 'demo')" class="form-group form-group-relative row align-items-center">
                            <label for="inputs_meta_web" class="col-sm-12">
                                {{ $t("meta_web") }}
                            </label>
                            <app-input id="inputs_meta_web" class="col-sm-12" type="text" v-model="inputs.meta_web" autocomplete="off" />
                            <a v-if="this.inputs.meta_web" :href="this.inputs.meta_web" target="_blank"><i class="custom-icon custom-icon-home"></i></a>
                        </div>

                        <div class="w-100 mb-2 tab-personal-data">
                            <div class="form-group row align-items-center col-sm-12 mb-0">
                                <app-attachment :table-id="tableFileId" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : temporaryId" class="loading-hidden"></app-attachment>
                                <div v-if="this.mailboxAttachmentOptions">
                                    <div v-for="(attachment, index) in this.mailboxAttachmentOptions.data" :key="index">
                                        <a :download="attachment.file_name" :href="'data:'+attachment.content_type+';base64,'+attachment.file_base64">{{ attachment.file_name }}</a>
                                    </div>
                                </div>
                                <app-attachment-upload-form :table-id="tableFileId" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : temporaryId" @parsed-cv="parsedCv"></app-attachment-upload-form>
                            </div>
                        </div>
                        <div class="form-group form-group-relative row align-items-center">
                            <div v-if="this.inputs.status == 300 && this.temporaryId != '0' && (this.inputs.email == '' || this.inputs.phone == '')" class="note note-info w-100 mt-2 mb-3">
                                <!-- Temporarly disabled this.inputs.status == 300 -->
                                <app-icon :name="'zap'" width="19" height="19" class="mt-0 mr-2" />
                                <strong>{{ $t("cv_parser_upload_cv") }}</strong> {{ $t("cv_parser_autofill_fields") }}
                            </div>
                        </div>

                        <div class="form-group row align-items-center mb-5 invisible">
                            <label for="inputs_status" class="col-sm-12 mb-0">
                                {{ $t("status") }}
                            </label>
                            <app-input id="inputs_status" class="col-sm-9" type="select" v-model="inputs.status" :list="statusLists" />
                        </div>
                    </div>
                    <div v-show="this.currentTab == 'employee'" class="modal-contentbox modal-contentbox-last">
                        <div v-if="this.tenant != 'studioreaktor'" class="form-group row align-items-center mb-2">
                            <label for="inputs_job" class="col-sm-10">
                                {{ $t("job_short") }}
                            </label>
                            <a href="/jobs" target="_blank" class="col-2 mb-1 text-right text-muted" :title="$t('edit_jobs')">
                                <app-icon :name="'edit'" width="18" height="18" />
                            </a>
                            <app-input id="inputs_job" class="col-sm-12" type="select" :list="this.jobOptions" v-model="inputs.job" :required="true" />
                            <div v-if="this.inputs.status < 3" class="col-sm-10 mb-1">
                                Datum přihlášky: {{ formatEventDate(inputs.created_at) }}
                            </div>
                        </div>
                        <div v-if="this.selectedUrl && this.inputs.status == 3 && this.tenant != 'studioreaktor'" class="form-group form-group-relative row align-items-center mb-3">
                            <div class="col-sm-12 mb-sm-0 text-muted">
                                {{ $t("start_of_onboarding") }}
                                {{ formatEventDate(inputs.event_date) }}
                                ({{ this.currentTimelineStateName }})
                                <button
                                    class="btn btn-primary btn-sm btn-circle btn-circle-xs ml-0"
                                    :class="this.inputs.timeline_state > 6 && this.inputs.event_date === null ? 'btn-pulse-animation' : ''"
                                    @click.prevent="
                                        submit();
                                        closeModalAndOpen('schedule');
                                    "
                                    :title="$t('change_date')"
                                >
                                    <app-icon :name="'edit-3'" width="19" height="19" class="mb-1" />
                                </button>
                            </div>
                        </div>
                        <div class="form-group row align-items-center">
                            <label for="inputs_residence" class="col-sm-12">
                                {{ $t("residence") }}
                            </label>
                            <app-input id="inputs_residence" class="col-sm-12" type="select" v-model="inputs.residence" :list="residenceLists" :required="false" />
                        </div>
                        <div v-if="this.inputs.status == 3" class="row">
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_banking_account" class="col-sm-12">
                                    {{ $t("meta_banking_account") }}
                                </label>
                                <app-input id="inputs_meta_banking_account" class="col-sm-12" type="text" v-model="inputs.meta_banking_account" />
                            </div>
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_salary" class="col-sm-12">
                                    {{ $t("salary") }}
                                </label>
                                <app-input id="inputs_salary" class="col-sm-12" type="number" v-model="inputs.salary" />
                            </div>
                        </div>
                        <div v-if="this.inputs.status == 3" class="row">
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_contract" class="col-sm-12">
                                    {{ $t("meta_contract") }}
                                </label>
                                <app-input
                                    id="inputs_meta_contract"
                                    class="col-sm-12"
                                    type="text"
                                    v-model="inputs.meta_contract"
                                />
                            </div>
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_cin" class="col-sm-12">
                                    {{ $t("meta_contract") }}
                                </label>
                                <app-input
                                    id="inputs_meta_cin"
                                    class="col-sm-12"
                                    type="text"
                                    v-model="inputs.meta_cin"
                                />
                            </div>
                        </div>
                        <div v-if="this.tenant == 'aliumproduction' || this.tenant == 'localhost'" class="form-group row align-items-center">
                            <label for="inputs_meta_employee_folder" class="col-sm-12">
                                    {{ $t("meta_employee_folder") }}
                                </label>
                                <app-input
                                    id="inputs_meta_employee_folder"
                                    class="col-sm-12"
                                    type="select"
                                    v-model="inputs.meta_employee_folder"
                                    :list="[
                                        { id: 0, value: 'Ne' },
                                        { id: 1, value: 'Ano' },
                                    ]"
                                />
                         </div>
                        <div v-if="this.inputs.status == 3" class="form-group row align-items-center">
                            
                            <label for="inputs_meta_taxpayer_declaration" class="col-sm-12">
                                    {{ $t("meta_taxpayer_declaration") }}
                                </label>
                                <app-input
                                    id="inputs_meta_taxpayer_declaration"
                                    class="col-sm-12"
                                    type="select"
                                    v-model="inputs.meta_taxpayer_declaration"
                                    :list="[
                                        { id: 0, value: 'Ne' },
                                        { id: 1, value: 'Ano' },
                                    ]"
                                />
                        </div>
                        <div v-if="this.inputs.status == 3" class="row">
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_medical_examination" class="col-sm-12">
                                    {{ $t("meta_medical_examination") }}
                                </label>
                                <app-input
                                    id="inputs_meta_medical_examination"
                                    class="col-sm-12"
                                    type="select"
                                    v-model="inputs.meta_medical_examination"
                                    :list="[
                                        { id: 0, value: 'Ne' },
                                        { id: 1, value: 'Ano' },
                                    ]"
                                />
                            </div>
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_medical_approval" class="col-sm-12">
                                    {{ $t("meta_medical_approval") }}
                                </label>
                                <app-input
                                    id="inputs_meta_medical_approval"
                                    class="col-sm-12"
                                    type="select"
                                    v-model="inputs.meta_medical_approval"
                                    :list="[
                                        { id: 0, value: 'Ne' },
                                        { id: 1, value: 'Ano' },
                                    ]"
                                />
                            </div>
                        </div>
                        <div v-if="this.inputs.status == 3" class="row">
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_criminal_record" class="col-sm-12">
                                    {{ $t("meta_criminal_record") }}
                                </label>
                                <app-input
                                    id="inputs_meta_criminal_record"
                                    class="col-sm-12"
                                    type="select"
                                    v-model="inputs.meta_criminal_record"
                                    :list="[
                                        { id: 0, value: 'Ne' },
                                        { id: 1, value: 'Ano' },
                                    ]"
                                />
                            </div>
                            <div class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_driver_card" class="col-sm-12">
                                    {{ $t("meta_driver_card") }}
                                </label>
                                <app-input id="inputs_meta_driver_card" class="col-sm-12" type="select"
                                    v-model="inputs.meta_driver_card"
                                    :list="[
                                        { id: 0, value: 'Ne' },
                                        { id: 1, value: 'Ano' },
                                    ]" />
                            </div>
                        </div>
                        <div class="row">
                            <div v-if="this.inputs.status == 3" class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_card_id" class="col-sm-12">
                                    {{ $t("card_id") }}
                                </label>
                                <app-input id="inputs_meta_card_id" class="col-sm-12" type="text" v-model="inputs.meta_card_id" :required="false" />
                            </div>
                            <div v-if="this.inputs.status == 3" class="form-group row align-items-center col-sm-12 col-md-6">
                                <label for="inputs_meta_personal_employee_number" class="col-sm-12">
                                    {{ $t("personal_employee_number") }}
                                </label>
                                <app-input id="inputs_meta_personal_employee_number" class="col-sm-12" type="text" v-model="inputs.meta_personal_employee_number" :required="false" />
                            </div>
                        </div>
                        <br /><br /><br /><br /><br />
                    </div>
                </form>
            </div>

            <div class="modal-contentbox modal-contentbox-checklist w-100">
                <div v-if="this.selectedUrl && this.timelineStatesLoaded && (this.inputs.status == 3 || this.inputs.timeline_state == 6) && this.checklistsLoaded" v-show="this.currentTab == 'hr_tasks'" class="modal-contentbox-row pt-0">
                    <div class="row tab-row">
                        <a v-if="this.inputs.timeline_state > 5 && this.selectedUrl" class="tab" :class="this.currentTab == 'hr_tasks' ? 'active' : ''" @click.prevent="showTab('hr_tasks')">
                            <app-icon :name="'check-square'" width="25" height="25" />
                            <span>{{ $t("internal_checklist") }}</span>
                        </a>
                        <a v-if="this.inputs.timeline_state > 5 && this.selectedUrl" class="tab" :class="this.currentTab == 'employee_tasks' ? 'active' : ''" @click.prevent="showTab('employee_tasks')">
                            <app-icon :name="'user-check'" width="25" height="25" />
                            <span>{{ $t("employee_checklist") }}</span>
                        </a>
                    </div>

                    <!-- :candidate-id='selectedUrl ? selectedUrl.replace(/\D/g, "") : `x`' -->
                    <app-checklist-form id="timeline_7" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="7" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[0] : ''" :type-id="1" :user-options="userOptions" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsHr ? checklistsHr.filter((t) => t.timeline_state == 7) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_8" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="8" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[1] : ''" :type-id="1" :user-options="userOptions" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsHr ? checklistsHr.filter((t) => t.timeline_state == 8) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_9" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="9" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[2] : ''" :type-id="1" :user-options="userOptions" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsHr ? checklistsHr.filter((t) => t.timeline_state == 9) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_10" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="10" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[3] : ''" :type-id="1" :user-options="userOptions" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsHr ? checklistsHr.filter((t) => t.timeline_state == 10) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_11" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="11" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[4] : ''" :type-id="1" :user-options="userOptions" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsHr ? checklistsHr.filter((t) => t.timeline_state == 11) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_12" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="12" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[5] : ''" :type-id="1" :user-options="userOptions" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsHr ? checklistsHr.filter((t) => t.timeline_state == 12) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_13" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="13" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[6] : ''" :type-id="1" :user-options="userOptions" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsHr ? checklistsHr.filter((t) => t.timeline_state == 13) : ''"></app-checklist-form>
                </div>
                <div v-if="this.selectedUrl && this.timelineStatesLoaded && (this.inputs.status == 3 || this.inputs.timeline_state == 6) && this.checklistsLoaded" v-show="this.currentTab == 'employee_tasks'" class="modal-contentbox-row pt-0">
                    <div class="row tab-row">
                        <a v-if="this.inputs.timeline_state > 5 && this.selectedUrl" class="tab" :class="this.currentTab == 'hr_tasks' ? 'active' : ''" @click.prevent="showTab('hr_tasks')">
                            <app-icon :name="'check-square'" width="25" height="25" />
                            <span>{{ $t("internal_checklist") }}</span>
                        </a>
                        <a v-if="this.inputs.timeline_state > 5 && this.selectedUrl" class="tab" :class="this.currentTab == 'employee_tasks' ? 'active' : ''" @click.prevent="showTab('employee_tasks')">
                            <app-icon :name="'user-check'" width="25" height="25" />
                            <span>{{ $t("employee_checklist") }}</span>
                        </a>
                    </div>

                    <app-checklist-form id="timeline_employee_7" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="7" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[0] : ''" :type-id="2" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter((t) => t.timeline_state == 7) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_employee_8" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="8" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[1] : ''" :type-id="2" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter((t) => t.timeline_state == 8) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_employee_9" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="9" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[2] : ''" :type-id="2" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter((t) => t.timeline_state == 9) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_employee_10" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="10" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[3] : ''" :type-id="2" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter((t) => t.timeline_state == 10) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_employee_11" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="11" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[4] : ''" :type-id="2" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter((t) => t.timeline_state == 11) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_employee_12" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="12" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[5] : ''" :type-id="2" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter((t) => t.timeline_state == 12) : ''"></app-checklist-form>

                    <app-checklist-form id="timeline_employee_13" :candidate-id="selectedUrl ? selectedUrl.replace(/\D/g, '') : `x`" :timeline-state-id="13" :timeline-state-name="timelineStatesLoaded ? timelineStatesLists[6] : ''" :type-id="2" :event-date="inputs.event_date" :current-timeline-state-id="inputs.timeline_state" :checklist-tasks="checklistsEmployee ? checklistsEmployee.filter((t) => t.timeline_state == 13) : ''"></app-checklist-form>
                </div>

                <div class="checklist-done-animation"></div>

                <div v-if="this.selectedUrl && (this.inputs.status == 3 || this.inputs.timeline_state == 6) && this.checklistsLoaded" v-show="this.currentTab == 'quiz'" class="modal-contentbox-row pt-0">
                    <div class="modal-contentbox-row pr-0 pt-0 pl-4 w-100 pb-5">
                        <div v-if="graduateOptions.quizTotal" class="">
                            <div class="col-12 col-md-6 p-4 float-left form-group row align-items-center mb-0">
                                <app-chart v-if="isActiveAtendeeStats && isActiveAtendeeStatsAndDisplayed" class="mb-primary mt-4" type="dough-chart" :width="320" :height="160" :labels="graduateStats.labels" :data-sets="graduateStats.dataSet" />
                            </div>
                            <div class="col-12 col-md-6 pt-5 pl-1 float-left form-group row align-items-center mb-0">
                                <div class="chart-data-list">
                                    <div class="row">
                                        <label for="inputs_finished" class="col-sm-12 mb-3">
                                            {{ $t("graduates_answers") }}
                                        </label>
                                        <div class="col-12" v-for="(item, index) in graduateStats.chartElement" :key="index">
                                            <div class="data-group-item" :style="item.color">
                                                <span class="square" :style="item.background_color" />
                                                {{ item.key }}
                                                <span class="value">{{ item.value }}</span>
                                            </div>
                                        </div>
                                        <div class="col-12 mt-4 pl-0">
                                            <label v-if="graduateOptions.quizInLast30Days.change.includes('-') && graduateOptions.quizInLast30Days.total > 0 && graduateOptions.quizBefore30Days.total > 0" for="" class="col-sm-12">
                                                {{ $t("in_the_last_30_days") }} <span style="color:rgb(188, 51, 93)">{{ $t("in_the_last_30_days_about") }} {{ graduateOptions.quizInLast30Days.change.replace("-", "") }} {{ $t("worst_answers_in_comparsion") }} &#9660; </span>
                                            </label>
                                            <label v-else-if="graduateOptions.quizInLast30Days.total > 0 && graduateOptions.quizBefore30Days.total > 0" for="" class="col-sm-12">
                                                {{ $t("in_the_last_30_days") }} <span style="color:rgb(86, 129, 139)">{{ $t("in_the_last_30_days_about") }} {{ graduateOptions.quizInLast30Days.change }} {{ $t("better_answers_in_comparsion") }} &#9650; </span>
                                            </label>
                                            <label v-else-if="graduateOptions.quizInLast30Days.total == 0 && graduateOptions.quizBefore30Days.total > 0" for="" class="col-sm-12"> {{ $t("in_the_last_30_days") }} {{ $t("in_the_last_30_days_no_answers") }} </label>
                                            <label v-else-if="graduateOptions.quizInLast30Days.total > 0 && graduateOptions.quizBefore30Days.total == 0" for="" class="col-sm-12">
                                                {{ $t("in_the_last_30_days_first_answers") }}
                                            </label>
                                            <label v-else-if="graduateOptions.quizInLast30Days.total == 0 && graduateOptions.quizBefore30Days.total == 0 && graduateOptions.totalText == 0" for="" class="col-sm-12">
                                                {{ $t("no_answers_yet") }}
                                            </label>
                                            <br />
                                            <div v-if="(graduateOptions.quizInLast30Days.total != 0 || graduateOptions.quizBefore30Days.total != 0) && graduateOptions.totalText == 0" class="col-sm-12 text-muted small">{{ $t("current_success") }} {{ graduateOptions.quizInLast30Days.correctRatio }} ({{ graduateOptions.quizInLast30Days.total }} {{ $t("answers_plural") }})<br />{{ $t("success_30_days_ago") }} {{ graduateOptions.quizBefore30Days.correctRatio }} ({{ graduateOptions.quizBefore30Days.total }} {{ $t("answers_plural") }})</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12 col-md-12 p-4 float-left form-group row align-items-center mb-0 card card-outline d-block text-muted">
                                <div class="col-12 col-md-6 text-center">
                                    <app-icon :name="'clock'" width="25" height="25" class="mr-2" />
                                    <b>{{ this.graduateOptions.totalDeadlines.ontimeRatio }}</b>
                                    {{ $t("answers_form_ontime") }}
                                </div>
                                <div class="col-12 col-md-6 text-center">
                                    <span v-if="this.graduateOptions.totalDeadlines.average == 1">
                                        <app-icon :name="'check'" width="25" height="25" class="mr-2" />
                                        <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t("day_before_deadline") }} {{ $t("average_delay") }}
                                    </span>
                                    <span v-else-if="this.graduateOptions.totalDeadlines.average >= 0 && this.graduateOptions.totalDeadlines.average < 5">
                                        <app-icon :name="'check'" width="25" height="25" class="mr-2" />
                                        <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t("days_before_deadline") }} {{ $t("average_delay") }}
                                    </span>
                                    <span v-else-if="this.graduateOptions.totalDeadlines.average >= 0">
                                        <app-icon :name="'check'" width="25" height="25" class="mr-2" />
                                        <b>{{ this.graduateOptions.totalDeadlines.average }}</b> {{ $t("days_plural_before_deadline") }} {{ $t("average_delay") }}
                                    </span>
                                    <span v-else>
                                        <app-icon :name="'x'" width="25" height="25" class="mr-2" />
                                        <b>{{ this.graduateOptions.totalDeadlines.average * -1 }}</b> {{ $t("day_after_deadline") }} {{ $t("average_delay") }}
                                    </span>
                                </div>
                            </div>

                            <div class="col-12 col-md-12 p-0 float-left form-group row align-items-center mb-0">
                                <div class="col-12 pr-0">
                                    <app-result-list :results="this.graduateOptions.data.quiz ? this.graduateOptions.data.quiz : ''" class="loading-hidden"></app-result-list>
                                </div>
                            </div>
                        </div>
                        <div v-else class="offset-md-2 col-md-8 mt-5 text-center">
                                <br />
                                <h5>
                                    <app-icon :name="'info'" class="mr-2" width="18" height="18" /> <b>{{ $t("no_results_or_yet_to_be_completed") }}</b>
                                </h5>
                                <a href="../onboarding/quiz" target="_blank" class="btn btn-primary mt-4">{{ $t("add_quizes_to_employee") }}</a
                                ><br /><br />
                        </div>
                    </div>


                    <div v-if="this.selectedUrl && this.inputs.status == 3" class="form-group row align-items-center">
                        <div class="onboarding-site-preview">
                            <a :href="'/employee/dashboard?impersonate='+this.inputs.id" class="btn btn-primary ml-0 ml-md-3 mt-3" target="_blank">
                                <app-icon :name="'eye'" width="19" height="19" class="mt-0 mr-2" />
                                <span class="primary">{{ $t("view_onboarding_as_employee") }}</span>
                            </button>
                        </div>
                    </div>


                </div>
                

                    
                </div>

                <div v-if="this.selectedUrl && (this.inputs.status == 3 || this.inputs.timeline_state == 6) && this.checklistsLoaded" v-show="this.currentTab == 'feedback'" class="modal-contentbox-row pt-0">
                    
                    
                    <div class="modal-contentbox-row pr-0 pt-0 pl-4 w-100 pb-5">
                        <div v-if="graduateOptions.total" class="">
                            <div class="col-12 col-md-12 p-0 float-left form-group row align-items-center mb-0">
                                <div class="col-12 pr-0">
                                    <app-result-list :results="this.graduateOptions.data.feedback ? this.graduateOptions.data.feedback : ''" class="loading-hidden"></app-result-list>
                                </div>
                            </div>
                        </div>
                        <div v-else class="offset-md-2 col-md-8 mt-5 text-center">
                                <br />
                                <h5>
                                    <app-icon :name="'info'" class="mr-2" width="18" height="18" /> <b>{{ $t("no_results_or_yet_to_be_completed") }}</b>
                                </h5>
                                <a href="../onboarding/quiz" target="_blank" class="btn btn-primary mt-4">{{ $t("add_quizes_to_employee") }}</a
                                ><br /><br />
                        </div>
                    </div>


                </div>
            </div>

            <div class="clearfix"></div>
        </template>
    </modal>
</template>
<script>
import { FormMixin } from "../../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../../Mixins/ModalMixin";
import { UserMixin } from "../../../../../../app/Components/Views/Auth/Mixins/UserMixin";
import AppLibrary from "../../../../../Helpers/AppLibrary";

export default {
    name: "AddModal",
    extends: AppLibrary,
    mixins: [FormMixin, ModalMixin, UserMixin],
    props: {
        tableId: String,
        selectedUrl: String,
        modalType: String,
        modalExtraButton: String
    },
    data() {
        return {
            preloader: false,
            timelineStatesLoaded: false,
            tableFileId: "file-table",
            tableCommentId: "comment-table",
            tableChecklistId: "checklist-table",
            tableQuestionnaireId: "questionnaire-table",
            tableMailboxId: "mailbox-table",
            isAddTaskHidden: true,
            showMainNote: true,
            showBanners: true,
            // status: 2,

            inputs: {
                gender: "male",
                residence: "1",
                source: "1",
                status: 2,
                phone: " ",
                email: "",
                linkedin: "",
                job: "",
                tag: [],
                timeline_state: 1,
                birthdate: "",
                event_date: "",
            },
            phone: "",
            statusLists: [
                { id: "1", value: 1 },
                { id: "2", value: 2 },
                { id: "3", value: 3 },
                { id: "4", value: 4 },
            ],
            timelineStatesLists: [
                { id: "1", value: "Noví uchazeči" },
                { id: "2", value: "Předvýběr" },
                { id: "3", value: "1. kolo" },
                { id: "4", value: "2. kolo" },
                { id: "5", value: "3. kolo" },
                { id: "6", value: "K přijetí" },
            ],
            timelineStatesOnboardingLists: [
                { id: "7", value: "Před nástupem", disabled: true },
                { id: "8", value: "První den", disabled: true },
                { id: "9", value: "Zkušební doba", disabled: true },
                { id: "10", value: "Zaměstnání" },
                { id: "11", value: "Povýšení" },
                { id: "12", value: "Mateřská" },
                { id: "13", value: "Offboarding" },
            ],
            genderLists: [
                { id: "male", value: this.$t("male") },
                { id: "female", value: this.$t("female") },
                { id: "other", value: this.$t("other") },
            ],
            ratingLists: [
                { id: "0", value: "0" },
                { id: "1", value: "1" },
                { id: "2", value: "2" },
                { id: "3", value: "3" },
            ],
            residenceLists: [
                { id: "1", value: "Praha - Stodůlky (701)" },
                { id: "2", value: "Praha - Smíchov (702)" },
                { id: "3", value: "Ostrava (703)" },
                { id: "4", value: "Brno (704)" },
                { id: "5", value: "Pardubice (705)" },
                { id: "6", value: "Zlín (706)" },
                { id: "7", value: "České Budějovice (707)" },
                { id: "8", value: "Plzeň (708)" },
                { id: "9", value: "Chomutov (709)" },
            ],
            payrollDepartmentLists: [
                { id: "A", value: "Kanceláře (A)" },
                { id: "AX", value: "Kancelář-Expedice (AX)" },
                { id: "E", value: "Expedice (E)" },
                { id: "V", value: "Výroba (V)" },
            ],
            sourceLists: [
                { id: "1", value: "Pracovní portály" },
                { id: "2", value: "Personální agentura" },
                { id: "3", value: "E-mail a telefon" },
                { id: "4", value: "Kariérní stránka" },
                { id: "5", value: "LinkedIn" },
                { id: "6", value: "Facebook" },
                { id: "7", value: "Twitter" },
                { id: "8", value: "Venkovní reklama" },
                { id: "9", value: "Jiné" },
            ],
            preboardingGuideStep: 1,
            modalId: "add-edit-Modal",
            modalTitle: this.$t("add"),
            currentTimelineStateName: "",
            currentTab: "employee",
            tenant: "",

            value: {},
            hasEventDate: false,
            tagPreloader: false,
            multiCreatePreloader: false,
            tags: [],
            skills: [],
            jobOptions: [],
            tagOptions: [],
            skillOptions: [],
            formQuizOptions: [],
            formFeedbackOptions: [],
            graduateOptions: {
                data: [],
                total: 0,
            },
            graduateStats: {},
            isActiveAtendeeStats: false,
            isActiveAtendeeStatsAndDisplayed: false,
            userOptions: [{ id: "1", value: "" }],
            mailboxOptions: [],
            mailboxAttachmentOptions: [],
            mailboxLoaded: false,

            candidateHistory: [],
            onboardingSiteId: 0,
            initialTimelineState: 0,
            eventHasPassed: false,
            checklistsHr: [],
            checklistsEmployee: [],
            checklistsLoaded: false,
            temporaryId: "0",
        };
    },
    created() {
        if (this.selectedUrl) {
            this.modalTitle = this.$t("edit");
            this.preloader = true;
        }

        if (this.selectedUrl === "") {
            this.temporaryId = Math.floor(Math.random() * 10000 + 900000).toString();
        } else if (window.location.href.indexOf("onboarding") > -1) {
            this.showTab("hr_tasks");
        }
    },
    mounted() {
        this.getTags();
        this.getSkills();
        this.getJobs();
        this.getUsers();

        // Fill status (for add and edit)
        if (this.tableId == "talentpool") {
            this.inputs.status = 1;
        } else if (this.tableId == "hiring") {
            this.inputs.status = 2;
            this.getTimelineStateNames();
        } else {
            this.inputs.status = 3;
            this.getTimelineStateNames();
        }

        // Display history of candidate
        if (this.selectedUrl) {
            this.axiosGet("admin/user/notifications?candidate_id=" + this.selectedUrl.replace(/\D/g, ""))
                .then((response) => {
                    this.candidateHistory = response.data.data;
                })
                .catch(({ response }) => {})
                .finally(() => {});
        }

        // Vertical line (css fix)
        setTimeout(function() {
            if ($(window).width() > 1200) {
                let firstBoxHeight = $(".modal-contentbox-first").outerHeight();
                let lastBoxHeight = $(".modal-contentbox-last").outerHeight();

                if (firstBoxHeight > lastBoxHeight) {
                    $(".modal-contentbox-last").css("height", firstBoxHeight);
                } else {
                    $(".modal-contentbox-first").css("height", lastBoxHeight);
                }
            }
        }, 1500);

        // Display default tab
        if (this.selectedUrl === "") {
            this.showTab("contacts");

            let _this = this;
            setTimeout(function() {
                    _this.showTab("contacts");
            }, 300);
        }

        // Add correct timeline_state on onboarding
        if (this.selectedUrl === "" && this.inputs.status == 3) {
            this.inputs.timeline_state = 7;
        }

        // Get current tenant settings
        this.getTenantSettings();
    },
    methods: {
        /**
         * Display
         * */

        showTab(tab) {
            this.currentTab = tab;

            if (this.currentTab == "hr_tasks" || this.currentTab == "employee_tasks") {
                this.showBanners = true;
            } else {
                this.showBanners = false;
            }

            if ($(window).width() < 1150) {
                if (this.currentTab == "superiors") {
                    this.showMainNote = true;
                } else {
                    this.showMainNote = false;
                }
            }
            if ($(window).width() > 768) {
                if (tab == "hr_tasks" && this.inputs.timeline_state > 6) {
                    // let _this = this;
                    // setTimeout(function(){ document.getElementById("timeline_"+_this.inputs.timeline_state).scrollIntoView(); }, 10);
                } else if (this.inputs.timeline_state > 6) {
                    document.getElementById("modal-contentbox-start").scrollIntoView();
                }

                if (tab == "employee_tasks" && this.inputs.timeline_state > 6) {
                    // let _this = this;
                    // setTimeout(function(){ document.getElementById("timeline_employee_"+_this.inputs.timeline_state).scrollIntoView(); }, 10);
                } else if (this.inputs.timeline_state > 6) {
                    document.getElementById("modal-contentbox-start").scrollIntoView();
                }
            }

            if (tab == "quiz") {
                let _this = this;

                setTimeout(function() {
                    _this.isActiveAtendeeStatsAndDisplayed = true;
                }, 300);
            }
        },

        showMiniTab(tab) {
            if (this.inputs.status == 3 || tab == "tab-history-data") {
                $("." + tab).slideToggle();
                let text = $(".title-" + tab).text();
                $(".title-" + tab).text(text == "+" ? "-" : "+");
            }
        },

        getUrlParameter(k) {
            var p = {};
            location.search.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(s, k, v) {
                p[k] = v;
            });
            return k ? p[k] : p;
        },

        /**
         * Actions
         * */

        sendToNextTimelineState() {
            let selectedBulkEditData = {};
            if (this.inputs.timeline_state == 1 && this.inputs.status == 1) {
                selectedBulkEditData = {
                    candidate_id: this.inputs.id,
                    timeline_state: 1,
                    status: 2,
                    job: this.inputs.job,
                };
            } else if (this.inputs.timeline_state == 7 && this.inputs.status == 3) {
                selectedBulkEditData = {
                    candidate_id: this.inputs.id,
                    phone: this.inputs.phone,
                    timeline_state: this.inputs.timeline_state,
                    status: 3,
                    job: this.inputs.job,
                };
                this.closeModalAndOpen("schedule");
                this.$hub.$emit("reload-" + this.tableId);
            } else if (this.inputs.timeline_state == 2 || this.inputs.timeline_state == 3 || this.inputs.timeline_state == 4) {
                selectedBulkEditData = {
                    candidate_id: this.inputs.id,
                    phone: this.inputs.phone,
                    timeline_state: this.inputs.timeline_state + 1,
                    status: 2,
                    job: this.inputs.job,
                };
                this.closeModalAndOpen("schedule");
                this.$hub.$emit("reload-" + this.tableId);
            } else {
                selectedBulkEditData = {
                    candidate_id: this.inputs.id,
                    timeline_state: this.inputs.timeline_state + 1,
                    job: this.inputs.job,
                };
            }

            this.axiosPatch({
                url: "admin/app/bulk/edit-candidates",
                data: selectedBulkEditData,
            })
                .then((response) => {
                    if (this.currentTimelineStateName) {
                        this.$toastr.s(this.$t("candidate_timeline_state_changed"));
                    } else if (this.tableId == "hiring") {
                        this.$toastr.s(this.$t("candidate_moved_to_onboarding"));
                    } else {
                        this.$toastr.s(this.$t("candidate_moved_to_hiring"));
                    }
                })
                .finally(() => {
                    this.tagPreloader = false;
                });

            this.$hub.$emit("reload-" + this.tableId);
            // @todo change to vue action
            $(".modal-header .close").trigger("click");
        },

        parsedCv(data) {
            // Fill parsed CV

            let response = "0";

            if (data.mobile === undefined || data.mobile === null || this.phone != "") {
                console.log("phone not filled in cv or already filled in profile");
            } else {
                this.inputs.phone = data.mobile[0];
                this.phone = data.mobile[0];
                response++;
            }

            if (data.email === undefined || data.email === null || this.inputs.email != "") {
                console.log("email not filled in cv or already filled in profile");
            } else {
                this.inputs.email = data.email[0];
                response++;
            }

            if (data.linkedin === undefined || data.linkedin === null || this.inputs.linkedin != "") {
                console.log("linkedin not filled in cv or already filled in profile");
            } else {
                this.inputs.linkedin = data.linkedin[0];
                response++;
            }

            if (response > 0) {
                let _this = this;
                setTimeout(function() {
                    _this.$toastr.s("Základní údaje ze CV doplněny");
                }, 600);
            }
        },

        tagStoreData(arg) {
            this.tagPreloader = true;
            this.addNewTagCreateOption(arg);
        },
        attachTag(tagId) {
            if (isNaN(tagId)) {
                // console.log(tagId+' is not a number');
            } else {
                this.tags.push(tagId);
                // console.log(tagId+' tag attached');
            }
        },

        detachTag(tagId) {
            let index = this.tags.indexOf(tagId);
            this.tags.splice(index, 1);
            // console.log(tagId,'detach');
        },

        addNewTagCreateOption(value) {
            this.axiosPost({
                url: "admin/app/tags",
                data: value,
            })
                .then((response) => {
                    if (response.data.data) {
                        // Update available tags
                        this.tagOptions = response.data.data;
                    }
                })
                .finally(() => {
                    this.tagPreloader = false;

                    // Add created tag to candidate tags
                    let latestElement = this.tagOptions[0].id;
                    this.attachTag(parseInt(latestElement));
                });
        },

        skillStoreData(arg) {
            this.multiCreatePreloader = true;
            this.addNewSkillCreateOption(arg);
        },

        attachSkill(skillId) {
            if (isNaN(skillId)) {
                // console.log(skillId+' is not a number');
            } else {
                this.skills.push(skillId);
                // console.log(skillId+' skill attached');
            }
        },

        detachSkill(skillId) {
            let index = this.skills.indexOf(skillId);
            this.skills.splice(index, 1);
            // console.log(skillId,'skill detach');
        },

        addNewSkillCreateOption(value) {
            this.axiosPost({
                url: "admin/app/skills",
                data: value,
            })
                .then((response) => {
                    if (response.data.data) {
                        // Update available skills
                        this.skillOptions = response.data.data;
                    }
                })
                .finally(() => {
                    this.multiCreatePreloader = false;

                    // Add created skill to candidate skills
                    let latestElement = this.skillOptions[0].id;
                    this.attachSkill(parseInt(latestElement));
                });
        },

        getTimelineStateNames() {
            // Actions - change timeline state

            let _this = this;
            setTimeout(function() {
                // Bugfix: Must be delayed, otherwise sometimes checklist does not show up at all

                _this
                    .axiosGet("admin/app/timeline-states?status=" + _this.inputs.status)
                    .then((response) => {
                        _this.timelineStatesLists = response.data;
                        let currentTimelineState = _this.timelineStatesLists.filter((t) => t.id == _this.inputs.timeline_state);
                        if (currentTimelineState != "" || typeof currentTimelineState !== "undefined") {
                            _this.currentTimelineStateName = currentTimelineState[0].value;
                        }
                        _this.timelineStatesLoaded = true;
                    })
                    .catch(({ response }) => {})
                    .finally(() => {});
            }, 1000);
        },

        getOnboardingSite(timelineState) {
            this.axiosGet("admin/app/onboardingsite?job=" + this.inputs.job + "&timeline_state=" + timelineState).then((response) => {
                if (response.data.length !== 0) {
                    this.onboardingSiteId = response.data[0].id;
                }
            });
        },

        showOnboardingSiteAsEmployee() {
            let winWidth = 350;
            let winHeight = 520;
            let winTop = screen.height / 2 - winHeight / 2;
            let winLeft = screen.width / 2 - winWidth / 2;
            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
            let timelineStateId = this.inputs.timeline_state - 6;

            let url = baseUrl + "onboarding/stranka?id=" + timelineStateId + "&job=1&impersonate=" + this.inputs.id;
            window.open(url, "window", "toolbar=no, menubar=no, status=no, resizable=no");
        },

        preboardingGuideStepAdd() {
            this.preboardingGuideStep++;

            if (this.preboardingGuideStep == 2) {
                this.showTab("employee_tasks");
            } else if (this.preboardingGuideStep == 3) {
                this.showTab("contacts");
            } else {
                this.showTab("superiors");
            }
        },

        preboardingGuideStepBack() {
            this.preboardingGuideStep--;

            if (this.preboardingGuideStep == 2) {
                this.showTab("employee_tasks");
            } else if (this.preboardingGuideStep == 3) {
                this.showTab("contacts");
            } else {
                this.showTab("superiors");
            }
        },

        /**
         * Get additional data
         * */

        getTags() {
            // Display available tags
            this.axiosGet("admin/app/tags")
                .then((response) => {
                    this.tagOptions = response.data.data;
                })
                .catch(({ response }) => {})
                .finally(() => {});
        },

        getSkills() {
            // Display available skills
            this.axiosGet("admin/app/skills")
                .then((response) => {
                    this.skillOptions = response.data.data;
                })
                .catch(({ response }) => {})
                .finally(() => {});
        },

        getJobs() {
            // Display available jobs
            this.axiosGet("admin/app/jobs")
                .then((response) => {
                    const jobOptionsArray = response.data.map(({ job: value, ...rest }) => ({
                        value,
                        ...rest,
                    }));

                    this.jobOptions = jobOptionsArray;
                })
                .catch(({ response }) => {})
                .finally(() => {
                    if (this.selectedUrl === "") {
                        this.inputs.job = this.jobOptions[0].id;
                    }
                });
        },

        getChecklists() {
            // Management
            this.axiosGet("admin/app/checklists?filter_with_candidate=" + this.inputs.id + "&filter_with_type=1&per_page=500&sortBy=id&orderBy=asc")
                .then((response) => {
                    const checklistsHr = response.data.data.filter((t) => t.type == 1);
                    const checklistsHrKeys = checklistsHr.map(({ status: completed, ...rest }) => ({
                        completed,
                        ...rest,
                    }));
                    const checklistsHrValues = checklistsHrKeys.map((obj) => (obj.completed === 1 ? { ...obj, completed: false } : { ...obj, completed: true }));

                    this.checklistsHr = checklistsHrValues;
                })
                .catch(({ response }) => {})
                .finally(() => {
                });

            // Employee
            this.axiosGet("admin/app/checklists?filter_with_candidate=" + this.inputs.id + "&per_page=500&sortBy=id&orderBy=asc")
                .then((response) => {
                    const checklistsEmployee = response.data.data.filter((t) => t.type == 2);
                    const checklistsEmployeeKeys = checklistsEmployee.map(({ status: completed, ...rest }) => ({
                        completed,
                        ...rest,
                    }));
                    const checklistsEmployeeValues = checklistsEmployeeKeys.map((obj) => (obj.completed === 1 ? { ...obj, completed: false } : { ...obj, completed: true }));

                    this.checklistsEmployee = checklistsEmployeeValues;
                })
                .catch(({ response }) => {})
                .finally(() => {
                    this.preloader = false;
                    this.checklistsLoaded = true;
                    // Display default tab
                    if (this.selectedUrl && (this.inputs.status == 3 || this.inputs.timeline_state == 6)) {
                        let _this = this;
                        setTimeout(function() {
                            if (_this.tenant == "aliumproduction" || _this.tenant == "localhost") {
                            } else {
                                _this.showTab("employee_tasks"); // bugfix - toggle views, otherwise data loaded, but checklist wont show sometimes
                                _this.showTab("hr_tasks");
                            }
                        }, 800);
                    }
                });
        },

        getForms() {
            let url = "admin/app/my-forms",
                reqData = {};

            // Quiz
            reqData.params = {
                status: 1,
                category: "quiz",
                job: this.inputs.job,
                id: this.inputs.id,
                tag: this.inputs.tag,
            };

            this.axiosGet(url, reqData)
                .then((response) => {
                    this.formQuizOptions = response.data;
                })
                .catch(({ response }) => {})
                .finally(() => {});

            // Feedback
            reqData.params = {
                status: 1,
                category: "feedback",
                job: this.inputs.job,
                id: this.inputs.id,
                tag: this.inputs.tag,
            };

            this.axiosGet(url, reqData)
                .then((response) => {
                    this.formFeedbackOptions = response.data;
                })
                .catch(({ response }) => {})
                .finally(() => {});
        },

        getGraduates() {
            // Display stats of finished vs unfinished forms by candidates
            let url = "admin/app/form-graduates",
                reqData = {};

            reqData.params = {
                candidate_id: this.inputs.id,
            };

            this.axiosGet(url, reqData)
                .then((response) => {
                    this.graduateOptions = response.data;

                    let attendees = this.atendeeOptions.data;
                    let graduateIds = response.data.graduateIds;

                    this.atendeeOptions.data = attendees.filter(function(attendee) {
                        return !graduateIds.includes(attendee.id); // data.id != response.data[0].id && data.id !== response.data[1].id;
                    });

                    this.graduateOptionsUnique.data = response.data.graduates;
                    this.graduateOptionsUnique.total = response.data.totalGraduates;
                })
                .catch(({ response }) => {})
                .finally(() => {
                    this.isActiveAtendeeStats = true;
                    this.getGraduateStats();
                });
        },

        getGraduateStats() {
            let totalCorrect = 0;
            let totalWrong = 0;
            let totalText = 0;
            if (this.graduateOptions.totalCorrectAnswers) {
                totalCorrect = this.graduateOptions.totalCorrectAnswers;
            }
            if (this.graduateOptions.totalWrongAnswers) {
                totalWrong = this.graduateOptions.totalWrongAnswers;
            }
            if (this.graduateOptions.totalText) {
                totalText = this.graduateOptions.totalText;
            }

            this.graduateStats = {
                labels: [this.$t("wrong"), this.$t("correct"), this.$t("form_type_text")],
                dataSet: [
                    {
                        borderWidth: 0,
                        backgroundColor: ["#bc335d", "#56818B", "#ffc571"],
                        data: [totalWrong, totalCorrect, totalText],
                    },
                ],
                chartElement: [
                    {
                        key: this.$t("wrong"),
                        value: totalWrong,
                        background_color: "background-color: #bc335d;",
                        color: "color: #bc335d;",
                    },
                    {
                        key: this.$t("correct"),
                        value: totalCorrect,
                        background_color: "background-color: #56818B;",
                        color: "color: #56818B;",
                    },
                    {
                        key: this.$t("form_type_text"),
                        value: totalText,
                        background_color: "background-color: #ffc571;",
                        color: "color: #ffc571;",
                    },
                ],
            };
        },

        getUsers() {
            let url = "admin/app/all-admin-users";
            this.axiosGet(url)
                .then((response) => {
                    this.userOptions = response.data;
                })
                .catch(({ response }) => {})
                .finally(() => {});
        },

        getMailbox() {
            if((this.tenant == "studioreaktor" || this.tenant == "localhost") && this.inputs.email){
                let url = "admin/app/mailbox", 
                    reqData = {};

                reqData.params = {
                    from: this.inputs.email,
                };

                this.axiosGet(url, reqData)
                    .then((response) => {
                        this.mailboxOptions = response.data;
                        this.mailboxLoaded = true;
                        this.getMailboxAttachments();
                    })
                    .catch(({ response }) => {})
                    .finally(() => {});
            }
        },
        getMailboxAttachments() {
            if(this.inputs.email){
                let url = "admin/app/mailbox-attachments", 
                    reqData = {};

                reqData.params = {
                    from: this.inputs.email,
                };

                this.axiosGet(url, reqData)
                    .then((response) => {
                        this.mailboxAttachmentOptions = response.data;
                    })
                    .catch(({ response }) => {})
                    .finally(() => {});
            }
        },

        /**
         * Modals
         */

        closeModalAndOpen(modal) {
            // Onboarding button on last timeline state
            if (this.inputs.timeline_state == 6) {
                this.inputs.status = 3;
            }
            let candidateDetails = [
                {
                    id: this.selectedUrl.replace(/\D/g, ""),
                    email: this.inputs.email,
                    phone: this.inputs.phone,
                    job: this.inputs.job,
                    name: this.inputs.name,
                    fullname: this.inputs.name + " " + this.inputs.surname,
                    status: this.inputs.status,
                    timeline_state: this.inputs.timeline_state,
                },
            ];

            this.$emit("close-and-open-modal", modal, candidateDetails);
        },

        /**
         * Load and save basic data
         * */

        beforeSubmit() {
            this.preloader = true;
        },

        submit() {
            // Convert selected tags to JSON string
            if (this.inputs.tag) {
                this.inputs.tag = JSON.stringify(this.tags);
            } else {
                this.inputs.tag = JSON.stringify([]);
            }

            // Convert selected skills to JSON string
            if (this.inputs.skill) {
                this.inputs.skill = JSON.stringify(this.skills);
            } else {
                this.inputs.skill = JSON.stringify([]);
            }

            // Convert selected jobs to JSON string
            if (this.inputs.job) {
                this.inputs.job = this.inputs.job;
            } else {
                this.inputs.job = [];
            }

            // Handle other fields
            if (this.inputs.birthdate) {
                this.inputs.birthdate = this.getDateFormatForBackend(this.inputs.birthdate);
            }

            if (this.inputs.status == 1) {
                this.inputs.timeline_state = 1;
            }
            this.inputs.phone = this.phone;
            this.save(this.inputs);
        },

        afterSuccess(response) {
            this.$toastr.s(response.data.message);
            this.$hub.$emit("reload-" + this.tableId);

            // Open schedule modal if event_date not set or is event already over
            let currentDateTime = moment();
            let alreadyTakenPlace = moment(currentDateTime).isAfter(this.inputs.event_date);

            if (this.inputs.status == 2 && (this.inputs.timeline_state == 3 || this.inputs.timeline_state == 4 || this.inputs.timeline_state == 5) && (!this.inputs.event_date || alreadyTakenPlace == true)) {
                this.closeModalAndOpen("schedule");
            }

            if (this.initialTimelineState != this.inputs.timeline_state) {
                // Animate badge notification
                let notifyBadge = this.inputs.timeline_state - 1;
                setTimeout(function() {
                    $(".timeline .state:eq(" + notifyBadge + ")").addClass("notify");
                }, 500);
                setTimeout(function() {
                    $(".timeline .state:eq(" + notifyBadge + ")").removeClass("notify");
                }, 1500);
            }

            this.checklistsLoaded = false;

            // Get last candidate Id on submit and replace temporary one used for upload
            if (this.selectedUrl === "") {
                this.axiosGet("admin/app/last-candidate")
                    .then((response) => {
                        if (response.data) {
                            this.afterGetLastCandidate(response.data);
                        }
                    })
                    .finally(() => {});
            }
        },

        afterGetLastCandidate(candidate) {
            // Get last candidate Id on submit and replace temporary one used for upload
            if (this.temporaryId != "0") {
                this.axiosPost({
                    url: "files/resolve-temporary-candidate",
                    data: { temp: parseInt(this.temporaryId), last: candidate.id },
                })
                    .then((response) => {})
                    .finally(() => {});
            }
        },

        afterSuccessFromGetEditData(response) {
            // Fill current tags of candidate
            if (response.data.tag) this.tag = response.data.tag;
            if (response.data.tag) {
                let added_tags = JSON.parse(this.tag);

                var _this = this;
                added_tags.forEach(function(entry) {
                    _this.attachTag(parseInt(entry));
                });
            }

            // Fill current tags of candidate
            if (response.data.skill) this.skill = response.data.skill;
            if (response.data.skill) {
                let added_skills = JSON.parse(this.skill);

                var _this = this;
                added_skills.forEach(function(entry) {
                    _this.attachSkill(parseInt(entry));
                });
            }

            // Fill other fields
            if (response.data.phone) this.phone = response.data.phone;
            this.inputs = response.data;
            this.checkEventDate(this.inputs.event_date);

            // Fill current jobs
            if (response.data.job) {
                this.job = response.data.job;
            } else {
                this.job = "0";
            }

            this.inputs.job = JSON.parse(this.job);

            // Prepare onboarding button
            if (this.inputs.status == 3) {
                this.getOnboardingSite(this.inputs.timeline_state);
            } else if (this.inputs.status == 2) {
                this.getOnboardingSite(7);
            }

            // Add visited candidate to history
            if (history.replaceState && location.href.indexOf("?profile") <= 0) {
                var newurl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?profile=" + this.inputs.id + "&timeline=" + this.inputs.timeline_state;
                window.history.replaceState({ path: newurl }, "", newurl);
            }

            // Save initial timeline_states
            this.initialTimelineState = this.inputs.timeline_state;

            // Fill checklists for management
            this.getChecklists();

            // Prepare forms and graduates
            this.getForms();
            this.getGraduates();
            if(this.inputs.status == 1 || this.inputs.status == 2){
                this.getMailbox();
            }

            // Do not show empty fields for non-admins if not responsible leader
            if(response.data.type == "warning"){
                this.$toastr.e(response.data.message);
                $("button.close").trigger("click");
            }
        },
        afterError(res) {
            this.$toastr.e(res.data.message);
        },
        clear() {
            this.inputs = {};
        },
        trim(text){
            return text.replace(/^ +/gm, '');
        },

        /**
         * Calendar
         */

        formatEventDate(date) {
            let formattedDate = " – " + this.$t("no_date");
            if (date) {
                formattedDate = moment(date).format("DD. MM. HH:mm");
                this.hasEventDate = true;
            }
            return formattedDate;
        },
        checkEventDate(date) {
            let currentDateTime = moment();
            let alreadyTakenPlace = moment(currentDateTime).isAfter(date);
            if (alreadyTakenPlace && (this.inputs.timeline_state == 3 || this.inputs.timeline_state == 4 || this.inputs.timeline_state == 5)) {
                this.eventHasPassed = true;
                this.showMainNote = true;
            } else if (this.inputs.timeline_state == 6) {
                this.showMainNote = true;
            } else {
                this.showMainNote = false;
            }
        },
        generateCalendar() {
            let language = "cs";
            let subject = "";
            let urlAddress = "";
            let jobOptions = this.jobOptions;
            let jobId = parseInt(this.inputs.job);
            let job = jobOptions.filter((obj) => {
                return obj.id === jobId;
            });

            var getUrl = window.location;
            var baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
            let description = "Telefon: " + this.inputs.phone + ", pracovní pozice: " + job[0].value;

            if (this.inputs.status == 3) {
                subject = "Nástup do zaměstnání - " + this.inputs.name + " " + this.inputs.surname;
                urlAddress = baseUrl + "onboarding?profile=" + this.inputs.id;
            } else {
                subject = this.timelineStatesLists[this.inputs.timeline_state - 1].value + " - " + this.inputs.name + " " + this.inputs.surname;
                urlAddress = baseUrl + "hiring?profile=" + this.inputs.id;
            }

            let begin = this.inputs.event_date;
            let stop = moment(this.inputs.event_date).add(1, "hours");
            let location = "";
            let urlGoogleMeet = "";
            if (this.inputs.event_location && this.inputs.event_location.indexOf("http") !== -1) {
                urlAddress = "";
                // @todo
            } else {
                location = "";
            }

            let organizer = this.user.loggedInUser.full_name;
            this.$ics.addEvent(language, subject, description, location, begin, stop, urlAddress, organizer);
            let fileName = subject;
            this.$ics.download(fileName);
            this.$ics.removeAllEvents();
        },

        /**
         * Tenant-based modifications
         */
        getTenantSettings() {
            if (window.location.href.indexOf("localhost") > -1) {
                this.tenant = "localhost";
            } else {
                this.tenant = window.location.host.split(".")[0];
            }

            if (this.tenant == "aliumproduction" || this.tenant == "localhost") {
                this.payrollDepartmentLists = [
                    { id: "B", value: "Butik (B)" },
                    { id: "BX", value: "Butiko-skladník (BX)" },
                    { id: "D", value: "Drobný nábytek (D)" },
                    { id: "J", value: "Dětské pokoje a kanceláře (J)" },
                    { id: "K", value: "Kuchyně (K)" },
                    { id: "L", value: "Ložnice (L)" },
                    { id: "N", value: "Nábytek (N)" },
                    { id: "O", value: "Obýváky (O)" },
                    { id: "Y", value: "Vykrývač (Y)" },
                ];
                this.residenceLists = [{ id: "1", value: "Praha - CitySense" }];
                this.showTab("employee");
            }
        },
    },
};
</script>
